import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("service") !== null && localStorage.getItem("service") !== undefined && localStorage.getItem("service") !== "") {

    data = JSON.parse(localStorage.getItem("service"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getservice: (state, action) => {
            localStorage.setItem("service", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getservice } = Insider.actions;
export default Insider.reducer;